import React from 'react';
import { Search } from 'lucide-react';
import PropCard from '../../cards/PropCard';
import Pagination from '@mui/material/Pagination';

const GridView = ({
  paginatedProps,
  totalPages,
  currentPage,
  onPageChange,
  addToCart,
  removeFromCart,
  setSelectedProp,
  handleRequestTransfer,
  userLists,
  onAddToList
}) => {
  return (
    <div className="space-y-4">
      {paginatedProps.length > 0 ? (
        <>
          <div className="space-y-4">
            {paginatedProps.map(prop => (
              <PropCard 
                key={prop.id} 
                prop={prop}
                onAddToCart={addToCart}
                onRemoveFromCart={removeFromCart}
                onViewDetails={setSelectedProp}
                onRequestTransfer={handleRequestTransfer}
                userLists={userLists}
                onAddToList={onAddToList}
              />
            ))}
          </div>
          <Pagination 
            totalPages={totalPages} 
            currentPage={currentPage} 
            onPageChange={onPageChange} 
          />
        </>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <Search className="h-16 w-16 mx-auto mb-4 opacity-50" />
          <p>No props found matching your criteria</p>
        </div>
      )}
    </div>
  );
};

export default GridView;